import React, { useMemo, useEffect, useState } from 'react'
import { Button, Card, Modal, Tooltip } from 'antd';
import useRequiredActionsStore from 'store/requiredActionsStore';
import { useLocation } from 'react-router-dom';


export default function RequiredActionsModal() {
  const requiredActions = useRequiredActionsStore(s => s.requiredActions);
  const requiredActionsShown = useRequiredActionsStore(s => s.requiredActionsShown);
  const setRequiredActionsShown = useRequiredActionsStore(s => s.setRequiredActionsShown);
  const canIgnore = useRequiredActionsStore(s => s.canIgnore);
  const modalOpen = useRequiredActionsStore(s => s.modalOpen);
  const setModalOpen = useRequiredActionsStore(s => s.setModalOpen);
  const location = useLocation();

  const pagesSuppressingModal = ['/seasonplayerregistrations_player'];

  useEffect(() => {
    const currentPath = location.pathname;
    const isPageSuppressingModal = pagesSuppressingModal.some(page => currentPath.indexOf(page) != -1);

    if (requiredActions.length > 0 && !requiredActionsShown && !isPageSuppressingModal) {
      setModalOpen(true);
      setRequiredActionsShown(true);
    }
  }, [requiredActions]);

  return requiredActions.length > 0 && (
    <Modal
      open={modalOpen}
      onCancel={() => setModalOpen(false)}
      width={'80vw'}
      title="Required Actions"
      className="max-w-[1000px]"
      closable={canIgnore}
      maskClosable={canIgnore}
      keyboard={canIgnore}
      footer={
        canIgnore && (
          <div className="flex justify-end mb-1">
            <Button size="small" type="link" onClick={() => setModalOpen(false)}>Remind me later</Button>
          </div>
        )
      }
    >
      <div className="mt-5 mb-6">
        <div className="mt-5 mb-5">Some items require your attention:</div>
        <div className="border border-gray-200 py-5 px-4 rounded-md">
          {
            requiredActions.length > 0 ? (
              <div className="flex flex-col gap-5">
                {requiredActions.map((step, index) => (
                  <div key={index} className="flex flex-col items-start gap-4 md:gap-2 md:flex-row md:justify-between">
                    <span>{step.text}</span>
                    <Tooltip title={step.buttonTooltip}>
                      <Button
                        type="primary"
                        size="small"
                        disabled={step.buttonDisabled}
                        onClick={() => {
                          setModalOpen(false);
                          step.buttonClick();
                        }}
                      >{step.buttonText}</Button>
                    </Tooltip>
                  </div>
                ))}
              </div>
            ) : (
              <div>No required actions</div>
            )
          }
        </div>
      </div>
    </Modal>
  )
}
